// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { S } from '../styles';

import ExamRecordCard from '../../ExamPage/components/ExamRecordCard';
import * as Markdown from '../../../components/Markdown';
import ScrollToTop from '../../ExamPage/components/ResultScrollToTop';
import ImgPopUp from '../../ExamPage/components/ExamImgPopUp';
import { FormattedMessage } from 'react-intl';

const ExamResultDetail = (props: any):JSX.Element => {
  const detail = props.detail;
  const setShowExamDetail = props.setShowExamDetail;
  const baseUrl = detail.markdownUrl;
  const answerUrl = detail.answerUrl;
  const reviewUrl = detail.reviewUrl;
  const [activeIndex, setActiveIndex] = useState(() => {
    if (detail.examResult.correctNumber + detail.examResult.wrongNumber !== 0) {
      return 'MultiSelect'
    } else if (detail.status === 'Reviewing') {
      return null
    } else {
      return 'Q&A'
    }
  });
  const [showImgUp, setShowImgUp] = useState(false);
  const [showImgUpImg, setShowImgUpImg] = useState('');

  const scoreList = {
    score: detail.examResult.qnaScore ? detail.examResult.score + detail.examResult.qnaScore : detail.examResult.score,
    qnaScore: detail.examResult.qnaScore,
    selectScore: detail.examResult.score,
    correctNumber: detail.examResult.correctNumber,
    wrongNumber: detail.examResult.wrongNumber,
    status: detail.status
  }

  const MultiSelectSection = (props: any) => {

    const multiSelectList = props.questionList;

    const ChoosedAnswer = (props: any) => {
      const wrongAnswer = props.wrongAnswer;
      return (
        <>
          { wrongAnswer.map((item: any, index: number) => {
            return (
              <S.ChoosedAnswer key={index}>
                <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
              </S.ChoosedAnswer>
            )
          })}
        </>
      )
    }

    const CorrectAnswer = (props: any) => {
      const correctAnswer = props.correctAnswer;
      return (
        <>
          { correctAnswer.map((item: any, index: number) => {
            return (
              <S.CorrectAnswer key={index}>
                <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
              </S.CorrectAnswer>
            )
          })}
        </>
      )
    }

    const QuestionArea = (props: any) => {
      const topicContent = props.topicContent;
      return (
        <>
          <S.ChoosedAnswerList>
            <S.AnswerTitle>Choosed Answer :</S.AnswerTitle>
            { topicContent.choosedAnswer.length === 0 ? null : <ChoosedAnswer wrongAnswer={topicContent.choosedAnswer}/>}
          </S.ChoosedAnswerList>
          <S.CorrectAnswerList>
            <S.AnswerTitle>Correct Answer :</S.AnswerTitle>
            { topicContent.answers.length === 0 ? null : <CorrectAnswer correctAnswer={topicContent.answers}/>}
          </S.CorrectAnswerList>
        </>
      )
    }

    return (
      <S.ExamScoreWrap>
        <S.ExamTopicArea>
          { multiSelectList.map((item: any, index: number) => {
            return (
              <S.ExamTopic key={index}>
                <S.ExamTopicQuestion>
                  <S.ExamTopicNumber><p>{parseInt(item.title)+1}.</p></S.ExamTopicNumber>
                  <S.ExamTopicText>
                    <Markdown.ExamMarkdown markdown={item.question} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
                  </S.ExamTopicText>
                </S.ExamTopicQuestion>
                <S.ExamTopicContent>
                  <QuestionArea topicContent = {item}/>
                </S.ExamTopicContent>
              </S.ExamTopic>
            )
          })}
          { multiSelectList.length === 0 ? (
            <>
              <S.QuestionsAllCorrect/>
              <S.ExamMultiSelectText>
                Congratulations!<br/>
                All multiple select questions are correct!
              </S.ExamMultiSelectText>
            </>
          ) : null }
        </S.ExamTopicArea>
        <ScrollToTop></ScrollToTop>
        <ImgPopUp img={showImgUpImg} showImgUp={showImgUp} setShowImgUp={setShowImgUp} />
      </S.ExamScoreWrap>
    )
  }

  const QASection = (props: any) => {
    const QAList = props.questionList;

    const CommentInput = (props: any) => {

      return (
        <>
          <S.ExamQAAnswerTitle><FormattedMessage id="K032" /></S.ExamQAAnswerTitle>
          <S.ExamQAScore value={props.score} disabled/>
          <S.ExamQAAnswerTitle><FormattedMessage id="K033" /></S.ExamQAAnswerTitle>
          { props.comment.length === 0 ? <S.ExamCommentText value={props.comment} disabled/> : (
            <>
              { props.comment.map((item: any, index:number) => {
                return (
                  <S.ExamCommentText key={index} value={item} disabled/>
                )
              })}
            </>
          ) }
          { props.reviewFileList && props.reviewFileList.length !== 0 ? <QnaReviewFileSection fileList={props.reviewFileList} reviewUrl={reviewUrl}/> : null }
        </>
      )
    }

    const QnaReviewFileSection = (props: any) => {
      const fileList = props.fileList;
      const reviewUrl = props.reviewUrl;

      return (
        <S.FileAnswerContainer>
          { fileList.map((item: string, index: number) => {
            return (
              <div key={index}>
                { item.includes('jpg') || item.includes('png') || item.includes('jpeg') ? (
                  <S.AnswerImg src={reviewUrl+'/'+item} alt={item}/>
                ) : (
                  <>
                    <S.AnswerFileIcon />
                    <S.AnswerDownloadLink href={reviewUrl+'/'+item} download={item}>{item}</S.AnswerDownloadLink>
                  </>
                )}
              </div>
            )
          })}
        </S.FileAnswerContainer>
      )
    }

    const QnaFileSection = (props: any) => {
      const fileName = props.fileName;
      const answerUrl = props.answerUrl;

      return (
        <S.FileAnswerContainer>
          { fileName.includes('jpg') || fileName.includes('png') || fileName.includes('jpeg') ? (
            <S.AnswerImg src={answerUrl+'/'+fileName} alt={fileName}/>
          ) : (
            <>
              <S.AnswerFileIcon />
              <S.AnswerDownloadLink href={answerUrl+'/'+fileName} download={fileName}>{fileName}</S.AnswerDownloadLink>
            </>
          )}
        </S.FileAnswerContainer>
      )
    }

    return (
      <S.ExamScoreWrap>
        <S.ExamTopicArea>
          { QAList.map((item: any, index: number) => {
            return (
              <S.ExamTopic key={index}>
                <S.ExamTopicQuestion>
                  <S.ExamTopicNumber><p>{parseInt(item.title)+1}.</p></S.ExamTopicNumber>
                  <S.ExamTopicText>
                    <Markdown.ExamMarkdown markdown={item.question} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
                  </S.ExamTopicText>
                </S.ExamTopicQuestion>
                <S.ExamTopicContent>
                  <S.ExamQAAnswerTitle><FormattedMessage id="K031" /></S.ExamQAAnswerTitle>
                  <S.ExamQAText value={item.answers} disabled/>
                  { item.fileName ? <QnaFileSection fileName={item.fileName} answerUrl={answerUrl}/> : null}
                  <CommentInput score={item.score} comment={item.comment} index={item.title} file={item.file} reviewFileList={item.reviewFileList}/>
                </S.ExamTopicContent>
              </S.ExamTopic>
            )
          })}
        </S.ExamTopicArea>
        <ScrollToTop></ScrollToTop>
      </S.ExamScoreWrap>
    )
  }

  return (
    <>
      <S.Return><S.ReturnIcon onClick={() => { setShowExamDetail(false) }} /></S.Return>
      <ExamRecordCard scoreList={scoreList}/>
      <S.TabNavigation isEmpty={(detail.examResult.correctNumber + detail.examResult.wrongNumber !== 0) || (detail.status !== 'Reviewing')}>
        { detail.examResult.answerList && detail.examResult.correctNumber + detail.examResult.wrongNumber !== 0 ? <S.TabLink isAcitve={activeIndex === 'MultiSelect' ? true : false} onClick={() => { setActiveIndex('MultiSelect') }}><FormattedMessage id="K025" /></S.TabLink> : null}
        { detail.examResult.answerQaList && detail.status !== 'Reviewing' ? <S.TabLink isAcitve={activeIndex === 'Q&A' ? true : false} onClick={() => { setActiveIndex('Q&A') }}><FormattedMessage id="K026" /></S.TabLink> : null }
      </S.TabNavigation>
      { activeIndex === 'MultiSelect' ? (
        <MultiSelectSection questionList={detail.examResult.answerList} />
      ) : (
        activeIndex === 'Q&A' && <QASection questionList={detail.examResult.answerQaList}/>
      )}
    </>
  );
};

export { ExamResultDetail as default };
